
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 24C6.01 24 .96 21.4.96 18.34V5.94C.96 3.09 4.42 0 12 0s11.04 3.08 11.04 5.95v12.39C23.04 21.4 18 24 12 24zM1.96 14.85v3.49C1.96 20.54 6.26 23 12 23s10.04-2.46 10.04-4.66v-3.5c-1.52 1.86-4.79 3.34-10.04 3.34S3.47 16.7 1.96 14.85zm0-2.61c0 1.99 2.67 4.94 10.04 4.94s10.04-2.95 10.04-4.94V8.55C20.53 10.41 17.25 11.9 12 11.9S3.47 10.41 1.96 8.55zm0-6.3c0 2 2.68 4.95 10.04 4.95s10.04-2.96 10.04-4.95S19.36 1 12 1 1.96 3.96 1.96 5.95z"}})])
          )
        }
      }
    